import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { InventoryFirmOrderSubmitDrawer } from '../../../../../../../../../../features/inventory/firm-order/inventory-firm-order-submit-drawer';
import { InventoryFirmOrdersTable } from '../../../../../../../../../../features/inventory/firm-order/inventory-firm-orders-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/order/_order/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsInventory,
      label: 'Firm Orders',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsInventory>,
  head: () => getPageHead('Firm Orders'),
  component: InventoryFirmOrderList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <InventoryFirmOrderSubmitDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Firm Order" size="small" />} />
          </RequiresAccess>

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsInventory}
    />
  );
}

function InventoryFirmOrderList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <InventoryFirmOrdersTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
